import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { copy } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
import { Stars } from './Stars';
export function TestimonialCarousel() {
  const [index, setIndex] = useState(0);
  const {
    t
  } = useLanguage();
  const current = testimonials[index];
  const go = (delta: number) => {
    setIndex(value => (value + delta + testimonials.length) % testimonials.length);
  };
  return <div data-id="element-309" data-mp="27vwvkictadk9">
      <div className="relative overflow-hidden rounded-xl bg-white p-8 shadow-sm ring-1 ring-navy-100 sm:p-12" data-id="element-310" data-mp="27v3y67zqt0es">
        <QuoteIcon width={40} height={40} aria-hidden="true" className="text-gold-300" data-id="element-311" data-mp="2coq2ncvr5xzi" />
        <div className="mt-5 min-h-[210px] sm:min-h-[190px]" aria-live="polite" aria-atomic="true" data-id="element-312" data-mp="1k6ugni9kaytg">
          <AnimatePresence mode="wait" data-id="element-313" data-mp="340094olfwe1h">
            <motion.blockquote key={`${current.name}-${t(current.quote).slice(0, 8)}`} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} data-id="element-314" data-mp="3435zs89pvnzb">
              <p className="font-display text-lg font-medium leading-relaxed text-navy-800 sm:text-xl" data-id="element-315" data-mp="2lbd3o4zcpmnd">
                “{t(current.quote)}”
              </p>
              <footer className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-316" data-mp="2gdtp13yqr7uw">
                <span className="font-bold text-navy-900" data-id="element-317" data-mp="2bd5xmh6lop05">{current.name}</span>
                <Stars rating={current.rating} data-id="element-318" data-mp="26ema4cccz55o" />
                {current.service && <span className="rounded-full bg-navy-50 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-navy-600" data-id="element-319" data-mp="9lj2q4jl89ye">
                    {t(current.service)}
                  </span>}
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
      </div>

      <div className="mt-6 flex items-center justify-between" data-id="element-320" data-mp="23twnumu6moak">
        <div className="flex gap-2" role="tablist" aria-label={t(copy.testimonials.select)} data-id="element-321" data-mp="1p4qtpda7bo9j">
          {testimonials.map((testimonial, position) => <button key={testimonial.name} type="button" role="tab" aria-selected={position === index} aria-label={`${t(copy.testimonials.reviewFrom)} ${testimonial.name}`} onClick={() => setIndex(position)} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-smooth ${position === index ? 'w-8 bg-gold-500' : 'w-2.5 bg-navy-200 hover:bg-navy-300'}`} data-id="element-322" data-mp="1u3la68kp50qh" data-mpi={position} />)}
        </div>
        <div className="flex gap-2" data-id="element-323" data-mp="11g7kmvjbv7ge">
          <button type="button" onClick={() => go(-1)} aria-label={t(copy.testimonials.prev)} className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-navy-200 bg-white text-navy-800 transition-colors duration-150 ease-smooth hover:bg-navy-50" data-id="element-324" data-mp="tv52nhgneegp">
            <ChevronLeftIcon width={20} height={20} aria-hidden="true" data-id="element-325" data-mp="yv9m9gcurpb5" />
          </button>
          <button type="button" onClick={() => go(1)} aria-label={t(copy.testimonials.next)} className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-navy-200 bg-white text-navy-800 transition-colors duration-150 ease-smooth hover:bg-navy-50" data-id="element-326" data-mp="b3ugfdlvapv5">
            <ChevronRightIcon width={20} height={20} aria-hidden="true" data-id="element-327" data-mp="g25rtsrt98fh" />
          </button>
        </div>
      </div>
    </div>;
}